import React, { useEffect } from "react";
import { getAllLabReport } from "../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";

const ReportDetails = () => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { labReport } = useSelector((state) => state.labReport);
  const labReportId = sessionStorage.getItem("labReportId");
  const newLabReport = labReport[0];
  const { token } = useSelector((state) => state.auth);

  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
  }, [dispatch, clinicId, labReportId, token]);


//   const serviceDetails = (() => {
//   const profiles = newLabReport?.profiles?.map(p => p.profileName) || [];
//   const tests = newLabReport?.tests?.map(t => t.testName) || [];
//   if (profiles.length > 0) {
//     return profiles.join(", ");
//   }
//   return tests.join(", ");
// })();
const serviceDetails = (() => {
  const profiles =
    newLabReport?.profiles?.map((p) => {
      return p?.profileName;
    }) || [];

  const profileTestIds =
    newLabReport?.profiles?.flatMap((p) =>
      p?.tests?.map((t) => t?._id)
    ) || [];

  const individualTests =
    newLabReport?.tests
      ?.filter((t) => !profileTestIds.includes(t?._id)) 
      .map((t) => t?.testName || t?.name) || [];

  return [...profiles, ...individualTests].join(", ");
})();
  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Report Details</h4>
        <div className="row">
          <div className="col-xl-4">
            <p>Name</p>
            <p className="border p-1 ps-3">
              {newLabReport?.patientId?.userId?.name}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Appointment Date</p>
            <p className="border p-1 ps-3">
              {newLabReport?.appDate
                ? new Date(newLabReport.appDate).toISOString().split("T")[0]
                : ""}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Appointment Id</p>
            <p className="border p-1 ps-3">{newLabReport?.appointmentId}</p>
          </div>
          <div className="col-xl-4">
            <p>Service</p>
            <p className="border p-1 ps-3">
              {newLabReport?.service?.serviceName}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Age </p>
            <p className="border p-1 ps-3">
              {`${newLabReport?.patientId?.userId?.age?.year} Y` ||
                `${newLabReport?.patientId?.userId?.age?.month} M` ||
                `${newLabReport?.patientId?.userId?.age?.day}`}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Gender </p>
            <p className="border p-1 ps-3">
              {newLabReport?.patientId?.userId?.gender}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Service Mode</p>
            <p className="border p-1 ps-3">{newLabReport?.serviceMode}</p>
          </div>
          <div className="col-xl-8">
            <p>Service Detail</p>
            <p className="border p-1 ps-3">{serviceDetails}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
